<template>
  <div class="module-product-box">
    <div class="name-module w-2/4" align="left">{{ item.name }}</div>
    <div class="list-lesson w-2/4">
      <div v-for="data in item.lessons[0].resources" :key="data.id">
        <button
          class="flex mb-2 text-left focus:outline-none"
          v-if="data.type === 6 || data.type === 1"
          @click="selectedResource(data)"
        >
          <span class="pr-2">
            <PadlockClose
              v-if="data.data.free === '0'"
              fill="none"
              stroke="#446daf"
              class="w-4"
            />

            <PadlockOpen
              v-if="data.data.free === '1'"
              fill="none"
              stroke="#e03d79"
              class="w-4"
            />
          </span>

          <span>{{ data.name }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PadlockClose from "./icons/Padlock_close.vue";
import PadlockOpen from "./icons/Padlock_open.vue";

export default {
  components: {
    PadlockClose,
    PadlockOpen,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    selectedResource(_item) {
      if (_item.data.free === '1') {
        this.$emit("selectedResource", _item);  
      }      
    },
  },
};
</script>

<style scoped>
.module-product-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 0.5px solid #707070;
}
</style>
